import './video-player.css'

import 'node_modules/video-react/dist/video-react.css'
import { FC } from 'react'
import { BigPlayButton, ControlBar, Player } from 'video-react'

import { VideoPlayerType } from './video-player.types'

export const VideoPlayer: FC<VideoPlayerType> = ({
  src,
  poster,
  videoRef,
  index,
  desktop,
  height,
  width,
  hideControlBars = false,
  disableBigPlayButton,
}) => {
  return (
    <Player
      playsInline
      poster={poster}
      fluid={false}
      width={width ? width : desktop ? 233 : 233}
      height={height ? height : desktop ? 233 : 175}
      ref={(el) => {
        if (videoRef) {
          videoRef.current[index] = el
        }
      }}
    >
      <BigPlayButton
        position="center"
        className={`${disableBigPlayButton && 'pointer-events-none'}`}
      />
      <source src={`${src}#t=0.25`} />

      {hideControlBars && <ControlBar disableCompletely />}
    </Player>
  )
}
